<template>
  <div id="app">
    <a
      class="sr-only sr-only-focusable skip-to-main"
      href="#main"
      ref="skipLink"
    >Skip to main content</a>
    <impersonation-banner />
    <gb-navbar />
    <license-banner />
    <div id="main">
      <router-view/>
    </div>

    <modal
      v-if="isSuperAdmin"
      v-model="showWikiTextPreviewer"
      size="lg"
      title="Wiki Text/Markdown Previewer"
      :footer="false"
      @input="setWikiTextPreviewer(false)">
      <wiki-text-preview v-if="showWikiTextPreviewer" />
    </modal>
    <Appcues v-if="!fetchingUser" :activate="true"/>
    <terms-of-use-modal v-if="termsNotAccepted && isAuthenticated"/>
  </div>
</template>

<script>
import GbNavbar from '@/components/nav/GbNavbar'
import LicenseBanner from '@/components/nav/LicenseBanner'
import ImpersonationBanner from '@/components/nav/ImpersonationBanner'
import WikiTextPreview from '@/components/WikiTextPreview'
import { mapState, mapMutations, mapGetters } from 'vuex'
import Appcues from '@/components/Appcues'
import TermsOfUseModal from '@/components/TermsOfUseModal'
import { mountLiveAnnouncer } from '@/util/live_announcer'

mountLiveAnnouncer()

export default {
  name: 'App',
  components: {
    GbNavbar,
    LicenseBanner,
    ImpersonationBanner,
    WikiTextPreview,
    Appcues,
    TermsOfUseModal,
  },
  metaInfo: {
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content:
          'Goalbook develops resources for teachers to differentiate instruction aligned to Common Core using UDL. Our toolkit contains Common Core IEP goals in Reading, Writing, and Math, as well as non-academic goals in Behavior and Autism.'
      }
    ]
  },
  computed: {
    ...mapState(['showWikiTextPreviewer']),
    ...mapState('user', {
      fetchingUser: state => state.fetching
    }),
    ...mapGetters('user', ['isSuperAdmin', 'eventMetadata', 'termsNotAccepted', 'isAuthenticated']),
    ...mapGetters('contentProfile', ['profileId'])
  },
  methods: {
    ...mapMutations(['setWikiTextPreviewer'])
  },
  eventContext() {
    return {
      content_profile_id: this.profileId,
      __vue_event_tracker_event_metadata: this.eventMetadata
    }
  },
  mounted() {
    this.$sendEvent('App Mounted')
  }
}
</script>

<style lang="less">
.skip-to-main:focus {
  left: 0;
  width: auto;
  height: auto;
  background: #fff;
  padding: 5px;
  display: inline-block !important;
  position: absolute;
  top: auto;
  z-index: 50000 !important;
}
</style>
